// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import { dayTheme } from "./dayTheme";
import { uuid } from 'uuidv4';
import Timeslots from "../../components/Timeslots";
import SelectDays from "../../components/SelectDays";
import { sendMetric } from '@atheneum/api/dist/lib';
import ClientCalendar from "../../components/ClientCalendar";
import ExpertCalendar from "../../components/ExpertCalendar";
import Button from "../../components/Button";
import { Header } from "../../components/Header";
import WizardIcon from "../../components/WizardIcon";
import RoundSlider from "../../components/RoundSlider";
import template from "./template";
import moment, { isMoment } from 'moment';
import 'moment-timezone';
import axios from 'axios';
import getEvents from "../../helpers/calendarHelpers/getEvents";
import pulse from "../../helpers/calendarHelpers/pulse";
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import "./Calendar.css"; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import Metric from "../../telemetry";
export const Scheduling = ({
  growlStore
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    schedule,
    selectedDate,
    readOnly,
    dayToRender,
    expertZone,
    clientZone,
    expertTimezone,
    availabilityStore_imp,
    ExpertOffsetSet,
    selectedLanguage
  } = state;
  const clientSideRef = useRef(null);
  const expertSideRef = useRef(null);
  useEffect(() => {
    const init = () => {
      clientSideRef.current.calendarInst.setDate(dayToRender._d);
      expertSideRef.current.calendarInst.setDate(dayToRender._d);
      const objToUpdate = {};

      if (!ExpertOffsetSet) {
        const setExpertOffset = moment().tz(expertTimezone.name);
        objToUpdate.expertZone = { ...expertZone,
          timezoneOffset: parseInt(setExpertOffset._offset)
        };
        objToUpdate.ExpertOffsetSet = true;
      }

      dispatch({
        type: 'UPDATE',
        payload: objToUpdate
      });
    };

    init(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTimezones = async e => {
    e.persist();
    const timezoneName = e.target.value;

    const translate = async (string, language) => {
      return axios({
        url: `${process.env.REACT_APP_TRANSLATE_URL}?q=${string}&t=${language}&s=en`,
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          authorization: window.localStorage.getItem('ngStorage-accessToken')
        }
      });
    };

    const client = e.target.id === 'handleTimezonesClient';
    const isSelected = selectedDate !== null ? moment(selectedDate).tz(timezoneName) : moment(clientSideRef.current.calendarInst._renderDate).tz(timezoneName);

    if (client) {
      dispatch({
        type: 'UPDATE',
        payload: {
          clientZone: { ...clientZone,
            timezoneOffset: parseInt(isSelected._offset)
          },
          clientTimezoneName: timezoneName
        }
      });
      return;
    }

    const languages = {
      chinese: 'zhTW',
      spanish: 'es',
      russian: 'ru',
      german: 'de',
      french: 'fr',
      italian: 'it',
      korean: 'ko',
      portuguese: 'pt',
      english: 'en',
      polish: 'pl',
      japanese: 'ja'
    };
    let timezoneTranslated;

    try {
      timezoneTranslated = await translate(timezoneName, languages[selectedLanguage.toLowerCase()]);
    } catch (error) {
      console.error(error);
    }

    dispatch({
      type: 'UPDATE',
      payload: {
        timezoneTranslated: timezoneTranslated.data.TranslatedText,
        expertZone: { ...expertZone,
          timezoneOffset: parseInt(isSelected._offset)
        },
        showExpertCountry: false,
        expertTimezone: availabilityStore_imp.staticData.timezones.find(tz => tz.name === timezoneName),
        expertTimezoneName: timezoneName
      }
    });
  };

  const getTimezoneString = date => {
    const momentDate = moment.tz(date, moment.tz.guess());
    const timezoneIdentifier = momentDate.format('z');
    const timezoneOffsetInMinutes = momentDate.utcOffset();
    const prefix = timezoneOffsetInMinutes >= 0 ? '+' : '';
    const hours = Math.floor(timezoneOffsetInMinutes / 60);
    const minutes = timezoneOffsetInMinutes % 60;
    const minutesString = minutes !== 0 ? ':' + minutes : '';
    return `${timezoneIdentifier}${prefix}${hours}${minutesString}`;
  };

  const changeDate = date => {
    const objToUpdate = {
      dayToRender: date
    }; // When its read only and there's at least on timeslot

    if (readOnly && !!schedule.timeslots[0]) {
      // opsTime get the start time of the time in the middle. There might be a better way to get this info
      const time = document.querySelector('#opsTime').innerHTML.split('-')[0].trim();
      const tz = getTimezoneString(schedule.timeslots[0].time.start).split(' ')[0];
      objToUpdate.timeOnDrop = `${date.format('MMM DD, YYYY')} at ${time} ${tz}`;
    }

    dispatch({
      type: 'UPDATE',
      payload: objToUpdate
    }); // To keep date picker selected date in sync with the calendar component

    if (date && isMoment(date)) {
      clientSideRef.current.calendarInst.setDate(date._d);
      expertSideRef.current.calendarInst.setDate(date._d);
    }
  };

  const onBeforeCreateSchedule = (e, type) => {
    const obj = {
      type,
      id: uuid(),
      time: {
        start: new Date(e.start).getTime(),
        end: new Date(e.end).getTime()
      },
      raw: {
        group: []
      }
    };

    if (obj.time.start < new Date().getTime()) {
      growlStore.showError('Cannot add availability in the past');
      sendMetric('scheduling.ScheduleInPast', 'sheduling', {
        status: 'error'
      });
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: [...schedule.availabilities]
          }
        }
      });
    } else {
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: [...schedule.availabilities, obj]
          }
        }
      });
    }
  };

  const handleUpdateEvents = event => {
    const {
      start,
      end
    } = event;
    const {
      id
    } = event.schedule;
    const newSchedule = schedule.availabilities.map(avb => {
      if (avb.id === id) {
        return { ...avb,
          time: {
            start: new Date(start).getTime(),
            end: new Date(end).getTime()
          }
        };
      } else {
        return avb;
      }
    });

    if (!!schedule.timeslots.length) {
      const timeslotStart = schedule.timeslots[0].time.start;
      const timeslotEnd = schedule.timeslots[0].time.end;
      const times = newSchedule.map(av => {
        return {
          start: av.time.start,
          end: av.time.end,
          id: av.id
        };
      });
      const result = times.filter(time => {
        return timeslotStart >= time.start && timeslotEnd <= time.end;
      });

      if (result.length < 2) {
        growlStore.showError('Cannot update availability which is connected to a scheduled timeslot');
        sendMetric('scheduling.UpdateAvailabilityInTimeslot', 'sheduling', {
          status: 'error'
        });
        return dispatch({
          type: 'SETSCHEDULE',
          payload: {
            schedule
          }
        });
      } else {
        return dispatch({
          type: 'SETSCHEDULE',
          payload: {
            schedule: { ...schedule,
              availabilities: newSchedule
            }
          }
        });
      }
    } else {
      return dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: newSchedule
          }
        }
      });
    }
  };

  const onBeforeUpdateSchedule = e => {
    handleUpdateEvents(e);
  };

  const onBeforeDeleteSchedule = async res => {
    if (res.schedule.raw.group && res.schedule.raw.group.length > 0) {
      const data = res.schedule.title === 'client' ? {
        clientAvailabilitiesToRemove: res.schedule.raw.group
      } : {
        expertAvailabilitiesToRemove: res.schedule.raw.group
      };

      try {
        await axios({
          method: 'post',
          url: `/api/expert-project-link/${availabilityStore_imp.epl.id}/schedule`,
          headers: {
            'Content-Type': 'application/json',
            authorization: window.localStorage.getItem('ngStorage-accessToken')
          },
          data: data
        });
        const result = schedule.availabilities.filter(avb => avb.id !== res.schedule.id);
        dispatch({
          type: 'SETSCHEDULE',
          payload: {
            schedule: { ...schedule,
              availabilities: result
            }
          }
        });
      } catch (error) {
        growlStore.showError(error.response.data.message);
        return;
      }
    } else {
      const result = schedule.availabilities.filter(avb => avb.id !== res.schedule.id);
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: result
          }
        }
      });
    }
  };

  const onClickSchedule = e => {
    const otherLocals = document.querySelectorAll('.showLocalTZ');
    otherLocals.length > 0 && Array.from(otherLocals).map(local => local.classList.remove('showLocalTZ'));
    const localTz = e.event.target.firstElementChild;
    localTz !== null && localTz.classList.add('showLocalTZ');
  };

  const clientAttr = {
    id: 'clientCal',
    height: '594px',
    ref: clientSideRef,
    usageStatistics: false,
    scheduleView: true,
    taskView: false,
    timezones: [clientZone],
    view: 'day',
    schedules: getEvents(schedule, 'client'),
    template: template,
    useDetailPopup: true,
    isReadOnly: readOnly,
    onBeforeDeleteSchedule: onBeforeDeleteSchedule,
    onBeforeCreateSchedule: e => onBeforeCreateSchedule(e, 'client'),
    onBeforeUpdateSchedule: e => onBeforeUpdateSchedule(e),
    onClickSchedule: e => onClickSchedule(e)
  };
  const expertAttr = {
    height: '594px',
    ref: expertSideRef,
    usageStatistics: false,
    scheduleView: true,
    taskView: false,
    timezones: [expertZone],
    view: 'day',
    schedules: getEvents(schedule, 'expert'),
    template: template,
    useDetailPopup: true,
    isReadOnly: readOnly,
    onBeforeDeleteSchedule: onBeforeDeleteSchedule,
    onBeforeCreateSchedule: e => onBeforeCreateSchedule(e, 'expert'),
    onBeforeUpdateSchedule: e => onBeforeUpdateSchedule(e),
    onClickSchedule: e => onClickSchedule(e)
  };
  const selectDaysAttr = {
    clientSideRef,
    expertSideRef,
    date: dayToRender,
    selectedDate,
    schedule,
    changeDate
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("div", {
    className: "scheduling_wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    title: "Open availability wizard"
  }, !readOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "addAvailButton",
    label: /*#__PURE__*/React.createElement(WizardIcon, null),
    onClick: () => dispatch({
      type: 'UPDATE',
      payload: {
        currentPath: 'availabilityForm'
      }
    })
  }))), window && window.outerWidth < 768 ? /*#__PURE__*/React.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/React.createElement(Button, {
    className: `button-part${readOnly ? ' active' : ''}`,
    label: 'Scheduling',
    onClick: () => {
      pulse();
      dispatch({
        type: 'UPDATE',
        payload: {
          readOnly: !readOnly
        }
      });
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: `button-part${!readOnly ? ' active' : ''}`,
    label: 'Availabilities',
    onClick: () => {
      pulse();
      dispatch({
        type: 'UPDATE',
        payload: {
          readOnly: !readOnly
        }
      });
    }
  })) : /*#__PURE__*/React.createElement(RoundSlider, {
    leftText: "Scheduling",
    rightText: "Availabilities",
    onClick: () => {
      pulse();
      dispatch({
        type: 'UPDATE',
        payload: {
          readOnly: !readOnly
        }
      });
      Metric.toggleMode(readOnly ? 'Scheduling' : 'Availabilities');
    },
    checked: !readOnly,
    id: "edit"
  })), /*#__PURE__*/React.createElement("div", {
    className: "views"
  }, /*#__PURE__*/React.createElement("div", {
    className: "formWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rowCalendar"
  }, /*#__PURE__*/React.createElement(SelectDays, selectDaysAttr)))), /*#__PURE__*/React.createElement("div", {
    className: "calendarContainer"
  }, /*#__PURE__*/React.createElement(ClientCalendar, {
    handleTimezones: handleTimezones,
    clientAttr: clientAttr,
    dayTheme: dayTheme
  }), readOnly && /*#__PURE__*/React.createElement(Timeslots, {
    clientSideRef: clientSideRef,
    expertSideRef: expertSideRef
  }), /*#__PURE__*/React.createElement(ExpertCalendar, {
    handleTimezones: handleTimezones,
    expertAttr: expertAttr,
    dayTheme: dayTheme
  }))));
};